import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { FieldGroupValue, FieldList } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { UserService } from 'src/app/services';

@Component({
  selector: 'app-prepared-for-modal',
  templateUrl: './prepared-for-modal.component.html',
  styleUrls: ['./prepared-for-modal.component.scss']
})
export class PreparedForModalComponent implements OnInit {
  
  subject: Subject<boolean>;
  businessName: string = '';
  reportId: string = '';

  preparedEntity: string = '';
  preparedAddress: string = '';

  @ViewChild('preparedForForm') preparedForForm: NgForm;
  formObj: any = {
    PREPARED_FOR_ENTITY: '',
    PREPARED_FOR_ENTITY_ADDRESS: ''
  }

  constructor(public bsModalRef: BsModalRef,
    public userService: UserService,
    private reportProvider: ReportProvider) { }

  ngOnInit(): void {
    this.formObj.PREPARED_FOR_ENTITY = this.preparedEntity;
    this.formObj.PREPARED_FOR_ENTITY_ADDRESS = this.preparedAddress;
  }

  /**
   * @description check and return prepared for entity
   */
  checkEntityName(): boolean {
    return this.formObj.PREPARED_FOR_ENTITY ? true : false;
  }

  /**
   * @description update prepared entity fields
   */
  callUpdateGroupAPI() {
    let objFieldArray = new Array<FieldList>();
    objFieldArray.push({ FIELD: 'PREPARED_FOR_ENTITY', VALUE: this.formObj.PREPARED_FOR_ENTITY });
    objFieldArray.push({ FIELD: 'PREPARED_FOR_ENTITY_ADDRESS', VALUE: this.formObj.PREPARED_FOR_ENTITY_ADDRESS });

    let objFieldGroup = new FieldGroupValue();
    objFieldGroup.GROUP = 'REPORT';
    objFieldGroup.FIELD_LIST = objFieldArray;

    this.reportProvider.updateReportFieldGroup(this.reportId, objFieldGroup).subscribe(res => {
      if (res.success) {
        this.confirm();
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description confirm click
   */
  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }
 
  /**
   * @description cancel click
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
